import { Box, Button, Typography } from '@mui/material';
import { IResource } from '../type';
import { TOGGLE_FLAG } from '../gql';
import { useMutation } from '@apollo/client';
import { useState } from 'react';
import CustomAvatarGroup from '../../common/custom-avatar-group';

interface INotificationCardProps {
  id: string;
  message: string;
  date: Date;
  flaged: boolean | null;
  resouces: IResource[];
  deliveredAt: string | null;
  skillName?: string;
}

const NotificationCard: React.FC<INotificationCardProps> = ({
  id,
  message,
  date,
  flaged,
  resouces,
  deliveredAt
}) => {
  const [toggleFlags] = useMutation(TOGGLE_FLAG);
  const [notifyFlag, setNotifyFlag] = useState<boolean | null>(flaged);
  const [isLoadingFlag, setIsLoadingFlag] = useState<boolean>(false);

  const handlFlagClick = async (): Promise<void> => {
    setIsLoadingFlag(true);
    await toggleFlags({
      variables: { id, isFlagged: !notifyFlag }
    }).then(() => {
      setNotifyFlag(!notifyFlag);
      setIsLoadingFlag(false);
    });
  };

  return (
    <Box
      sx={{
        backgroundColor: deliveredAt ? 'inherit' : '#ECF0FF',
        marginBottom: '16px',
        padding: '10px',
        borderRadius: '12px',
        border: '1px solid rgba(95, 99, 104, 0.5)',
        display: 'flex',
        gap: '20px',
        flexDirection: {
          sm: 'row',
          xs: 'column'
        },
        justifyContent: 'space-between',
        width: '100%'
      }}
    >
      <Box
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          overflowWrap: 'break-word',
          wordBreak: 'break-word',
          flexGrow: 1
        }}
      >
        <Typography variant="body1" sx={{ fontSize: '14px' }}>
          {message}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          minWidth: '150px',
          marginLeft: {
            xs: '10px'
          }
        }}
      >
        <CustomAvatarGroup
          members={resouces}
          max={3}
          size={40}
          fontSize={'16px'}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          height: '100%',
          flexShrink: 0,
          minWidth: '200px'
        }}
      >
        <Typography
          sx={{
            fontSize: '13px',
            fontWeight: '400',
            color: 'rgba(116, 119, 127, 1)',
            width: 'auto',
            marginBottom: '8px'
          }}
        >
          {new Date(date).toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          })}
        </Typography>
        {flaged !== null && (
          <Button
            disabled={isLoadingFlag}
            onClick={() => {
              void (async () => {
                await handlFlagClick();
              })();
            }}
            sx={{
              backgroundColor: notifyFlag ? '#C9E6FF' : '#E2ECF6',
              borderRadius: '100px',
              height: '40px',
              padding: '10px 24px',
              textTransform: 'none'
            }}
          >
            {notifyFlag ? 'Flag Raised' : 'Raise a flag'}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default NotificationCard;
